import { useParams, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { getSubdomainPage } from "@/subdomains/pages";

export default function SubdomainPreview() {
  const { slug } = useParams();
  const Page = getSubdomainPage(slug);

  if (!Page) {
    return <Navigate to="/sites" replace />;
  }

  return (
    <>
      <Page />
      <Toaster position="bottom-right" richColors closeButton />
    </>
  );
}
